import { LuLoaderPinwheel } from "react-icons/lu";
import React from 'react';

export const Spinner = () => {
  return (
    <div className="flex justify-center items-center">
      <LuLoaderPinwheel className="animate-spin h-8 w-8 text-cyan-600" />
    </div>
  );
}
